/* Package JSON Import will be here */
import { push } from "connected-react-router";
import moment from 'moment';
import { filter, forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCartCountApi, orderSummaryApi } from "../services/home";
import { submitCartApi, clearCartApi } from "services/cart";
import { ISubmitCartApiInputParam } from "models/cartModels";
import { getPrincipals } from "reducers/principals";
import { orderUploadApi, orderHistoryDetailsApi } from "../services/orders";
import { removeProductFromOrderReducer, orderUpload, initializeOrderState, removeAllChangedProductFromOrderReducer } from "reducers/orders";
import { appRoutesConst } from "app/navigation";
import {
  getErrorObject,
  normalizeByGroup,
  mergeMultipleSchemeOrderSummary,
  getCartPriceDetails,
  errorToast
} from "../utilities/utils";
import Constants from "../utilities/appConstants";
import { IOrderUploadParams } from "models/orderModels";
import { showMsgFromJson } from "reducers/common";
import { GAAddTransaction } from "hooks/googleAnalyticsHooks";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
import { IOrderSummaryParams } from "models/homeModels";
import { GARemoveFromCart } from "hooks/googleAnalyticsHooks"
/* Project Import will be here */

export const types = {
  CART_COUNT_REQUEST: "home/CART_COUNT_REQUEST",
  CART_COUNT_SUCCESS: "home/CART_COUNT_SUCCESS",
  CART_COUNT_FAILURE: "home/CART_COUNT_FAILURE",
  CART_DETAIL_REQUEST: "home/CART_DETAIL_REQUEST",
  CART_DETAIL_SUCCESS: "home/CART_DETAIL_SUCCESS",
  CART_DETAIL_FAILURE: "home/CART_DETAIL_FAILURE",
  CART_DELETE_REQUEST: "home/CART_DELETE_REQUEST",
  CART_DELETE_SUCCESS: "home/CART_DELETE_SUCCESS",
  CART_DELETE_FAILURE: "home/CART_DELETE_FAILURE",
  CART_SUBMIT_REQUEST: "home/CART_SUBMIT_REQUEST",
  CART_SUBMIT_SUCCESS: "home/CART_SUBMIT_SUCCESS",
  CART_SUBMIT_FAILURE: "home/CART_SUBMIT_FAILURE",
  CART_UPLOAD_REQUEST: "home/CART_UPLOAD_REQUEST",
  CART_UPLOAD_SUCCESS: "cart/CART_UPLOAD_SUCCESS",
  CART_UPLOAD_FAILURE: "cart/CART_UPLOAD_FAILURE",
  CHANGE_QUANTITY: "orders/CHANGE_QUANTITY",
  CHANGE_CASE_QUANTITY: "orders/CHANGE_CASE_QUANTITY",
  UPDATE_EXPRESS_DELIVERY_DATE: "orders/UPDATE_EXPRESS_DELIVERY_DATE",
  UPDATE_SELECTED_ADDR_ID: "orders/UPDATE_SELECTED_ADDR_ID",
  REMOVE_LOCAL_CART_MANUALLY: "cart/REMOVE_LOCAL_CART_MANUALLY",
  ALLOW_TO_CHECKOUT: "cart/ALLOW_TO_CHECKOUT"
};

const initialState = {
  count: null,
  isLoading: false,
  error: null,
  data: {},
  ids: [],
  groupIds: [],
  freeProducts: [],
  standardDeliveryDate: null,
  expressDeliveryDate: null,
  deleteLoading: false,
  deleteAllLoading: false,
  uploadLoading: false,
  submitLoading: false,
  selectedAddrId: 0,
  isCartInitiated: false,
  allowToCheckout: false
};

export const cart = (state = initialState, action) => {
  switch (action.type) {
    case types.CART_COUNT_REQUEST:
    case types.CART_COUNT_SUCCESS:
    case types.CART_COUNT_FAILURE:
      return cartCountReducer(state, action);

    case types.CHANGE_QUANTITY:
      let { id, count, isChanged } = action.payload;

      /* Check for count undefined, If it is undefined take the count value from cart */
      if (count === undefined && state.data[id] !== undefined)
        count = state.data[id].pieceQTY;

      return {
        ...state,
        data: { ...state.data, [id]: { ...state.data[id], pieceQTY: count, isChanged: isChanged } }
      };

    case types.CHANGE_CASE_QUANTITY:
      let { product_id, case_count, caseChange } = action.payload;

      /* Check for count undefined, If it is undefined take the count value from cart */
      if (case_count === undefined && state.data[product_id] !== undefined)
        case_count = state.data[product_id].caseQTY;

      return {
        ...state,
        data: { ...state.data, [product_id]: { ...state.data[product_id], caseQTY: case_count, isChanged: caseChange } }
      };

    case types.CART_DETAIL_REQUEST:
    case types.CART_DETAIL_SUCCESS:
    case types.CART_DETAIL_FAILURE:
      return cartDetailsReducer(state, action);

    case types.CART_DELETE_REQUEST:
    case types.CART_DELETE_SUCCESS:
    case types.CART_DELETE_FAILURE:
      return cartDeleteReducer(state, action);

    case types.CART_SUBMIT_SUCCESS:
    case types.CART_SUBMIT_REQUEST:
    case types.CART_SUBMIT_FAILURE:
    case types.REMOVE_LOCAL_CART_MANUALLY:
      return cartSubmitReducer(state, action);

    case types.CART_UPLOAD_REQUEST:
    case types.CART_UPLOAD_SUCCESS:
    case types.CART_UPLOAD_FAILURE:
      return cartUploadReducer(state, action);

    case types.UPDATE_EXPRESS_DELIVERY_DATE:
      return {
        ...state,
        expressDeliveryDate: action.payload.expressDeliveryDate
      };

    case types.UPDATE_SELECTED_ADDR_ID:
      return {
        ...state,
        selectedAddrId: action.payload.addrId
      };

    case types.ALLOW_TO_CHECKOUT:
      return {
        ...state,
        allowToCheckout: true
      };

    default:
      return state;
  }
};

const cartCountReducer = (state, action) => {
  switch (action.type) {
    case types.CART_COUNT_REQUEST:
      return { ...state, isLoading: true };
    case types.CART_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        count: action.payload
      };
    case types.CART_COUNT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};

const cartDetailsReducer = (state, action) => {
  switch (action.type) {
    case types.CART_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: action.payload.isLoading
      };
    case types.CART_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isCartInitiated: true,
        ...action.payload
      };
    case types.CART_DETAIL_FAILURE:
      return {
        ...initialState,
        isLoading: false,
        isCartInitiated: true,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export const cartDeleteReducer = (state, action) => {
  switch (action.type) {
    case types.CART_DELETE_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case types.CART_DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteAllLoading: false,
        error: null
      };
    case types.CART_DELETE_FAILURE:
      return {
        deleteLoading: false,
        deleteAllLoading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};

const cartSubmitReducer = (state, action) => {
  switch (action.type) {
    case types.CART_SUBMIT_REQUEST:
      return {
        ...state,
        submitLoading: true
      };
    case types.CART_SUBMIT_SUCCESS:
    case types.REMOVE_LOCAL_CART_MANUALLY:
      return {
        ...initialState,
        error: null,
        submitLoading: false,
        isCartInitiated: true
      };
    case types.CART_SUBMIT_FAILURE:
      return {
        ...state,
        submitLoading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};

const cartUploadReducer = (state, action) => {
  switch (action.type) {
    case types.CART_UPLOAD_REQUEST:
      return {
        ...state,
        uploadLoading: true
      };
    case types.CART_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        error: null
      };
    case types.CART_UPLOAD_FAILURE:
      return {
        ...state,
        uploadLoading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export const getCartCount = () => {
  return async dispatch => {
    dispatch({ type: types.CART_COUNT_REQUEST });
    try {
      const response = await getCartCountApi();
      const payload = response.data.Count;
      dispatch({
        type: types.CART_COUNT_SUCCESS,
        payload
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.CART_COUNT_FAILURE,
        payload: { error: message }
      });
    }
  };
};

/* Fetch the cart products */
/* If isFromCartProductDelete is true we no need to enable isLoading to true */
export const getCartDetails = (isFromCartPage = false, isFromCartProductDelete = false) => {
  return async (dispatch, getState) => {
    const appSettings = getState().appSettings;

    dispatch({
      type: types.CART_DETAIL_REQUEST,
      payload: { isLoading: isFromCartProductDelete ? false : true }
    });

    /* fetch the principal details when the details is not available */
    if (getState().principals.ids.length === 0)
      await dispatch(getPrincipals());

    try {
      /* Get the Cart information */
      const requestParam: IOrderSummaryParams = { ReqCode: isFromCartPage ? "MyCart" : "" };
      const response = await orderSummaryApi(requestParam);

      /* Merge multiple schemed products - Only non free products */
      const nonFreeProducts = filter(response.data.Data, (o) => { return !o.IsFree; });

      /* Merge same product with multiple scheme */
      let data = mergeMultipleSchemeOrderSummary(nonFreeProducts);

      /* Convert case and piece count from QTY */
      data = convertCaseAndPieceQty(data, appSettings, false);
      const payload = normalizeByGroup({
        data: data,
        key: "ProductId",
        groupKey: "PrincipalId"
      });

      /* Get the order delivery date from the cart response */
      payload.standardDeliveryDate = data[0].DeliveryDate

      /* Separate free products from the response if any - Assign free products */
      const freeProducts = filter(response.data.Data, (o) => { return o.IsFree; });
      payload.freeProducts = convertCaseAndPieceQty(freeProducts, appSettings, true);

      await dispatch({ type: types.CART_DETAIL_SUCCESS, payload });

      /* Check for SIH 0 */
      await checkForCartSIHProducts(dispatch, appSettings, response);

      /* Re initialize order state */
      await dispatch(initializeOrderState(Constants.REDUCER_CART));
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.CART_DETAIL_FAILURE, payload: { error: message } });

      /* Check for SIH 0 */
      checkForCartSIHProducts(dispatch, appSettings, error);
    }
  };
};

/* Check for SIH 0 warning and error */
const checkForCartSIHProducts = (dispatch, appSettings, response) => {
  if (response.data && response.data.isShowSIHWarning) {
    if (appSettings.isRestrictSIHProducts && response.data.isShowSIHWarning)
      dispatch(showMsgFromJson("common.alerts.warning.outOfStockError", Constants.WARNING));
    else if (!appSettings.isRestrictSIHProducts && response.data.isShowSIHWarning)
      dispatch(showMsgFromJson("common.alerts.warning.outOfStockWarning", Constants.WARNING));
  }
}

/* Convert the QTY into case and piece QTY */
const convertCaseAndPieceQty = (productList, config, isFromFreeProduct) => {
  /* Change the case piece QTY values */
  forEach(productList, (o) => {
    if (config.isEnablePlaceOrderCase) {
      /* Check for free product QTY */
      if (isFromFreeProduct) {
        /* Case - Enable, Piece - Disable, ConversionQTY - 0 (Assign all qty to case) */
        if (!config.isEnablePlaceOrderPiece && o.ConversionQty === 0) {
          o.caseQTY = o.Qty;
          o.pieceQTY = 0;
        }
        /* Case - Enable, Piece - Disable, ConversionQTY > 0 (assign divided qty to case) */
        else if (!config.isEnablePlaceOrderPiece && o.ConversionQty > 0) {
          o.caseQTY = ~~(o.Qty / o.ConversionQty) + (((o.Qty / o.ConversionQty) % 1) > 0 ? 1 : 0);
          o.pieceQTY = 0;
        }
        /* Case - Enable, Piece - Enable, ConversionQTY - Any thing (Assign all qty to piece) */
        else if (config.isEnablePlaceOrderPiece) {
          o.caseQTY = 0;
          o.pieceQTY = o.Qty
        }
      }
      else {
        o.caseQTY = ~~(o.Qty / o.ConversionQty);
        o.pieceQTY = (o.Qty % o.ConversionQty);
      }
    }
    else {
      o.caseQTY = 0;
      o.pieceQTY = o.Qty
    }

    o.isChanged = false
  });

  return productList;
}

/* deleteCartItem - Delete item from the cart. This will trigger the API and remove the cart product from the database and update the order reducer*/
export const deleteCartItem = ids => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.CART_DELETE_REQUEST,
      payload: { deleteLoading: true, deleteAllLoading: false }
    });

    let oldCartData = getState().cart.data;
    let requestObject: IOrderUploadParams = [];
    forEach(ids, (o) => {
      requestObject.push({
        PId: o,
        Qty: 0,
        Price: oldCartData[o].Price,
        PName: oldCartData[o].ProductName,
        DiscountId: oldCartData[o].DiscountId,
        SchemeId: oldCartData[o].SchemeId,
        PrincipalId: oldCartData[o].PrincipalId,
        ImageUrl: oldCartData[o].ImageUrl,
        DistributorId: oldCartData[o].DistributorId,
        UomId: oldCartData[o].UomId,
        GroupId: oldCartData[o].GroupId,
        GroupName: oldCartData[o].GroupName,
        UomCount: 1
      })
    });

    try {
      /* Trigger API to remove the deleted cart product from database */
      await orderUploadApi(requestObject);

      /*  GA - track individual item delete item details */
      if (window.isEnableGA) {
        const clearedProductList = [];
        forEach(ids, (o) => { clearedProductList.push({ item_id: o, quantity: oldCartData[o].Qty, item_name: oldCartData[o].ProductName }); });
        GARemoveFromCart(false, null, clearedProductList);
      }

      /* Trigger ActionMethod to remove the product from order reducer */
      await dispatch(removeProductFromOrderReducer(ids));

      /*  errorToast to remove item in card page  */
      dispatch(showMsgFromJson("common.alerts.success.productRemovedSuccessfully", Constants.SUCCESS));

      /* Re-fetch the cart details */
      await dispatch(getCartDetails(false, true))

      dispatch({ type: types.CART_DELETE_SUCCESS });
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.CART_DELETE_FAILURE,
        payload: { error: message }
      });
    }
  };
};

/* Clear all cart items */
export const clearCart = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.CART_DELETE_REQUEST,
      payload: { deleteLoading: false, deleteAllLoading: true }
    });
    try {
      /* Trigger API to remove the deleted cart product from database */
      await clearCartApi();

      /* Capture clear cart products in google analytics */
      if (window.isEnableGA)
        GARemoveFromCart(true, getState().cart, null);

      /* Re-fetch the cart details */
      await dispatch(getCartDetails());

      /* Remove all the products in the order reducer and re-initialize the order reducer */
      await dispatch(removeAllChangedProductFromOrderReducer(false));

      /* Display the success toast message */
      dispatch(showMsgFromJson("common.alerts.success.clearCartSuccess", Constants.SUCCESS));

      dispatch({ type: types.CART_DELETE_SUCCESS });
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.CART_DELETE_FAILURE,
        payload: { error: message }
      });
    }
  };
};

/* Final step to order the products - This will trigger from OrderCheckOut page Done button */
export const submitCart = id => {
  return async (dispatch, getState) => {
    /* Get the cart data before clear the data */
    const cartData = getState().cart;

    dispatch({ type: types.CART_SUBMIT_REQUEST });
    try {
      /* SubmitCartApi request parameter */
      let deliveryDate = "";
      if (cartData.expressDeliveryDate !== null && cartData.expressDeliveryDate !== "")
        deliveryDate = moment(cartData.expressDeliveryDate, Constants.DD_MM_YYYY).format(Constants.YYYY_MM_DD);
      else if (cartData.standardDeliveryDate !== "")
        deliveryDate = moment(cartData.standardDeliveryDate, Constants.DD_MM_YYYY).format(Constants.YYYY_MM_DD);

      const requestParam: ISubmitCartApiInputParam = {
        DeliveryDate: deliveryDate,
        AddressId: cartData.selectedAddrId
      };

      /* Call the submitCartApi to submit the products added in the cart */
      const orderSubmitResponse = await submitCartApi(requestParam);

      await dispatch({ type: types.CART_SUBMIT_SUCCESS });

      /* Remove all the products in the order reducer and re-initialize the order reducer */
      await dispatch(removeAllChangedProductFromOrderReducer(false));

      /* Display the success toast message */
      dispatch(showMsgFromJson("common.alerts.success.orderSubmit", Constants.SUCCESS));

      /* Navigate the user to the orderHistory page after the successful transaction */
      await dispatch(clearHistoryFilter());

      dispatch(push(appRoutesConst.orderHistory));

      /* GA - Track order submit */
      if (window.isEnableGA && orderSubmitResponse.data.Data.length > 0) {
        forEach(orderSubmitResponse.data.Data, async (e) => {
          await dispatch(googleAnalyticTrackOrderSubmit(e));
        });

      }
    }
    catch (error) {
      /* Extract the error message and error code from the response object */
      const { message } = getErrorObject(error);
      dispatch({
        type: types.CART_SUBMIT_FAILURE,
        payload: { error: message }
      });

      dispatch(showMsgFromJson("order.checkout.error.somethingWentWrong", Constants.ERROR));
    }
  };
};

/* Add the GA transaction after the successful place order  */
const googleAnalyticTrackOrderSubmit = (orderId) => {
  return async (dispatch, getState) => {
    const appConfig = getState().appSettings;
    const user = getState().localStore.user;

    try {
      /* Fetch the order history details from the server */
      const response = await orderHistoryDetailsApi({ OrderId: orderId, NeedSummary: true });
      /* Merge multiple schemed products - Only non free products */
      const nonFreeProducts = filter(response.data.Data, (o) => { return !o.IsFree; });
      /* Merge same product with multiple scheme */
      let productList = mergeMultipleSchemeOrderSummary(nonFreeProducts);
      /* Convert case and piece count from QTY */
      productList = convertCaseAndPieceQty(productList, appConfig, false);

      GAAddTransaction(response.data.OrderSummary[0], productList, user);
    }
    catch (error) {
      /* TODO: Handle GA OrderViewDetails error response */
    }
  }
}

/* Update the edited cart product count and navigate the retailer to product checkout page */
export const cartUpload = (navigateTo: string, minOrderValue: number, validationMessage: string) => {
  return async (dispatch, getState) => {
    try {
      /* Request for upload order */
      dispatch({ type: types.CART_UPLOAD_REQUEST });

      /* Call the actual order upload action method, this will trigger the API and update the updated product count */
      await dispatch(orderUpload(true));

      /* Make success the upload order */
      dispatch({ type: types.CART_UPLOAD_SUCCESS });

      /* Check for min order value */
      if (minOrderValue !== null) {
        const cartPriceDetails = getCartPriceDetails(getState().cart.data);

        if (cartPriceDetails.totalEffectivePrice >= minOrderValue) {
          dispatch({ type: types.ALLOW_TO_CHECKOUT });
          dispatch(push(navigateTo));
        }
        else {
          errorToast({ content: validationMessage });
        }
      }
      else {
        dispatch({ type: types.ALLOW_TO_CHECKOUT });
        dispatch(push(navigateTo));
      }
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.CART_UPLOAD_FAILURE, payload: { error: message } });
    }
  };
};

/* Update the product express delivery date */
export const updateExpressDeliveryDate = dateString => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_EXPRESS_DELIVERY_DATE,
      payload: { expressDeliveryDate: dateString }
    });
  };
};

/* Update the product express delivery date */
export const updateSelectedAddrId = (addrId) => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_SELECTED_ADDR_ID,
      payload: { addrId: addrId }
    });
  };
};

/* Remove all the locally added products from the cart */
export const removeLocalCartManually = () => {
  return async (dispatch) => {
    dispatch({
      type: types.REMOVE_LOCAL_CART_MANUALLY
    });
  };
}